export { default } from './withMobileDialog';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/withMobileDialog/index.js
// module id = 169
// module chunks = 0